var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button"},[_c('input',{staticStyle:{"display":"none"},attrs:{"type":"file","id":"OCR","accept":"image/*","name":"OCR"},on:{"change":(e) => { _vm.fileOCR(e.target.files, e) }}}),_c('label',{staticClass:"image_label",attrs:{"for":"OCR"}},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }